const CARRIER_TRACKING = new Map([
    ["ups", { url: "https://www.ups.com/track?loc=en_US", parameter: "tracknum" }],
    ["fedex", { url: "https://www.fedex.com/fedextrack/", parameter: "trknbr" }],
    ["usps", { url: "https://tools.usps.com/go/TrackConfirmAction", parameter: "tLabels" }],
    ["dhl", { url: "https://www.dhl.com/us-en/home/tracking.html?submit=1", parameter: "tracking-id" }],
]);

export function getCarrierTrackingUrl(carrier, trackingNumber) {
    const definition = CARRIER_TRACKING.get((carrier || "").trim().toLowerCase());
    const number = (trackingNumber || "").trim();
    if (!definition || !number) return null;

    const url = new URL(definition.url);
    url.searchParams.set(definition.parameter, number);
    return url.toString();
}
